// extracted by mini-css-extract-plugin
export var label = "_db-1";
export var reminder = "_db-0";